
$(function () {
  $('#assignmentsTable').dataTable({
    iDisplayLength: 25,
    "aaSorting": [[0, 'asc'], [2, 'asc'], [1, 'asc']],
    "columnDefs": [{ "orderable": false, "targets": 5 }]
  });
});
